import React, {useRef, useEffect, useState } from 'react'
import 'react-datepicker/dist/react-datepicker.css'


const CreateUpdateCardForm = ({allCard,onFormClose,onFormSubmit
  }) => {
    const inputRef = useRef(null);
    const [isUpdate,setIsUpdate] = useState(false)
    const [formData, setFormData] = useState({
      type : "create",
      cardId: "",
      userId : "",
      username: "",
      department : ""
    });

    useEffect(() => {
        // Focus the input on load
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, []);
  
  const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        // Update formData with the new value
        setFormData((prevData) => ({ ...prevData, [name]: value }));
      
        // Determine the field being updated (cardId or userId)
        const isCardId = name === 'cardId';
        const isUserId = name === 'userId';
      
        if(isCardId){
          const matchingItem = allCard.find(item => 
            (isCardId && item.cardId === value) 
          );
          if (matchingItem) {
            // Update formData and set to update mode if a match is found
            setFormData({
              type: "update",
              cardId: matchingItem.cardId,
              userId: matchingItem.userid,
              username: matchingItem.username,
              department : matchingItem.department
           })
           setIsUpdate(true);
          }else{
          
          };
        }
        if(isUserId){
          const matchingItem = allCard.find(item => 
            (isUserId && item.userid === value) 
          );
          if (matchingItem) {
            // Update formData and set to update mode if a match is found
            setFormData({
              type: "update",
              cardId: matchingItem.cardId,
              userId: matchingItem.userid,
              username: matchingItem.username,
              department : matchingItem.department
           })
           setIsUpdate(true);
          }else{
           
          };
        }  
      };    
    return (
      <div>
        <div className="modal-overlay">
            <div className="modal-content">
              <h3>Thông tin nhân viên</h3>
  
              <div className="form-group">
                <label>Mã thẻ :</label>
                <input
                  type="text"
                  name="cardId"
                  ref={inputRef}
                  className="form-control"
                  placeholder="Quét thẻ RFID"
                  value={formData.cardId}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label>Phòng ban :</label>
                <input
                  type="text"
                  name="department"
                  className="form-control"
                  placeholder="Phòng ban"
                  value={formData.department}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group">
                <label>Mã nhân viên:</label>
                <input
                  type="text"
                  name="userId"
                  className="form-control"
                  placeholder="Mã nhân viên"
                  value={formData.userId}
                  onChange={handleInputChange}
                />
              </div>
  
              <div className="form-group">
                <label>Họ và tên:</label>
                <input
                  type="text"
                  name="username"
                  className="form-control"
                  placeholder="Nhập họ và tên nhân viên"
                  value={formData.username}
                  onChange={handleInputChange}
                />
              </div>
  
              <div className="modal-actions">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    onFormClose()
                  }}
                >
                  Quay lại
                </button>

                {!isUpdate && (
                  <button className="btn btn-success" onClick={() =>{
                    onFormSubmit(formData)
                  }}>
                    Tạo mới
                  </button>
                )}

                {isUpdate && (
                  <button className="btn btn-third" onClick={() =>{
                    onFormSubmit(formData)
                  }}>
                    Cập nhật
                  </button>
                )}
                
              
              </div>
            </div>
          </div>
        {/* Styles */}
        <style jsx>{`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }
          .modal-content {
            background: white;
            padding: 20px;
            border-radius: 8px;
            width: 500px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          }
          .form-group {
            margin-bottom: 15px;
          }
          .form-group label {
            display: block;
            font-weight: bold;
            margin-bottom: 5px;
          }
          .form-control {
            width: 100%;
            padding: 8px;
            box-sizing: border-box;
          }
          .modal-actions {
            display: flex;
            justify-content: flex-end;
            gap: 10px;
          }
          .btn {
            padding: 8px 12px;
            cursor: pointer;
          }
          .btn-primary {
            background: #007bff;
            color: white;
            border: none;
          }
          .btn-success {
            background: #28a745;
            color: white;
            border: none;
          }
          .btn-third {
            background: #009ef7;
            color: white;
            border: none;
          }
          .btn-secondary {
            background: #6c757d;
            color: white;
            border: none;
          }
        `}</style>
      </div>
    );
  };

export default CreateUpdateCardForm